module.exports = __webpack_public_path__ + "12_hair_brown.e35428c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/12_hair_brown.png
// module id = xcJA
// module chunks = 0